export default __webpack_public_path__ + "static/media/icon-Connect-Knowledgebase.b33b80f5.svg";